var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "events-semanal-view" },
    [
      _vm.weeks.length === 0
        ? _c("el-empty", { attrs: { description: "Nenhum evento neste mês" } })
        : _c(
            "div",
            { staticClass: "d-flex flex-column", style: { gap: "16px" } },
            _vm._l(_vm.weeks, function(week) {
              return _c(
                "div",
                { key: week.number, staticClass: "border rounded p-1" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "p-1 border rounded mb-2",
                      style: { backgroundColor: "#f0f9ebCC" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between flex-wrap",
                          style: { gap: "12px" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "pl-2 d-flex align-items-center",
                              style: { gap: "10px" }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-date",
                                style: { color: "#67C23A" }
                              }),
                              _vm._v(" "),
                              _c(
                                "h6",
                                { staticClass: "mb-0 font-weight-bolder" },
                                [_vm._v("Semana " + _vm._s(week.number))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tag",
                                {
                                  staticClass: "rounded-pill",
                                  attrs: {
                                    size: "mini",
                                    type: "success",
                                    effect: "plain"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(week.events.length) +
                                      " evento" +
                                      _vm._s(
                                        week.events.length === 1 ? "" : "s"
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.isExport &&
                          (_vm.isSelectionModeActive(week.number) ||
                            _vm.getSelectableEvents(week).length > 0)
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: _vm.isSelectionModeActive(week.number)
                                      ? "danger"
                                      : "primary",
                                    plain: "",
                                    round: "",
                                    disabled: _vm.isWeekButtonDisabled(
                                      week.number
                                    )
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.toggleWeekSelection(
                                        week.number
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    class: _vm.isSelectionModeActive(
                                      week.number
                                    )
                                      ? "el-icon-close"
                                      : "el-icon-check"
                                  }),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.isSelectionModeActive(week.number)
                                          ? "Cancelar seleção"
                                          : "Selecionar eventos"
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isSelectionModeActive(week.number)
                    ? _c("div", { staticClass: "week-actions-panel mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between flex-wrap",
                            style: { gap: "12px" }
                          },
                          [
                            _c("span", { style: { fontSize: "13px" } }, [
                              _c("b", [
                                _vm._v(_vm._s(_vm.selectedEventIds.length))
                              ]),
                              _vm._v(
                                "\n                        evento" +
                                  _vm._s(
                                    _vm.selectedEventIds.length === 1 ? "" : "s"
                                  ) +
                                  " selecionado" +
                                  _vm._s(
                                    _vm.selectedEventIds.length === 1 ? "" : "s"
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center flex-wrap",
                                style: { gap: "8px" }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "info",
                                      plain: "",
                                      disabled:
                                        !_vm.canReproveSelected ||
                                        _vm.isProcessingAction
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.handleDisapproveSelectedEvents()
                                      }
                                    }
                                  },
                                  [
                                    _vm.isProcessingAction
                                      ? _c("i", {
                                          staticClass: "el-icon-loading"
                                        })
                                      : _c("i", {
                                          staticClass: "el-icon-close"
                                        }),
                                    _vm._v(
                                      "\n                            Reprovar\n                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "success",
                                      plain: "",
                                      disabled:
                                        !_vm.canApproveSelected ||
                                        _vm.isProcessingAction
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.handleApproveSelectedEvents()
                                      }
                                    }
                                  },
                                  [
                                    _vm.isProcessingAction
                                      ? _c("i", {
                                          staticClass: "el-icon-loading"
                                        })
                                      : _c("i", {
                                          staticClass: "el-icon-check"
                                        }),
                                    _vm._v(
                                      "\n                            Aprovar\n                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "warning",
                                      plain: "",
                                      disabled:
                                        !_vm.canRevokeSelected ||
                                        _vm.isProcessingAction
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.handleRevokeApprovedSelectedEvents()
                                      }
                                    }
                                  },
                                  [
                                    _vm.isProcessingAction
                                      ? _c("i", {
                                          staticClass: "el-icon-loading"
                                        })
                                      : _c("i", {
                                          staticClass: "el-icon-refresh-left"
                                        }),
                                    _vm._v(
                                      "\n                            Revogar aprovação\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column",
                      style: { gap: "8px" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "rounded",
                                  attrs: {
                                    "empty-text": "Nenhum evento encontrado",
                                    data: week.events,
                                    align: "center",
                                    border: "",
                                    "row-key": "id",
                                    "row-class-name": _vm.getRowClassName
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { width: "40", align: "center" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function(scope) {
                                            return [
                                              _vm.isSelectionModeActive(
                                                week.number
                                              )
                                                ? _c("el-checkbox", {
                                                    attrs: {
                                                      value: _vm.isWeekFullySelected(
                                                        week
                                                      ),
                                                      indeterminate: _vm.isWeekPartiallySelected(
                                                        week
                                                      ),
                                                      disabled:
                                                        _vm.getSelectableEvents(
                                                          week
                                                        ).length === 0
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.toggleWeekHeaderCheckbox(
                                                          week
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return _vm.isSelectionModeActive(
                                              week.number
                                            )
                                              ? [
                                                  !_vm.isEventCheckable(
                                                    scope.row
                                                  )
                                                    ? _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            content: _vm.getNotCheckableReason(
                                                              scope.row
                                                            ),
                                                            placement: "right"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            [
                                                              _c(
                                                                "el-checkbox",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      "",
                                                                    value: false
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _c("el-checkbox", {
                                                        attrs: {
                                                          value: _vm.isEventSelected(
                                                            scope.row.id
                                                          )
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.toggleEventSelection(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      })
                                                ]
                                              : undefined
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Data do evento",
                                      width: "130",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center justify-content-center"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-time"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "ml-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatDate(
                                                            scope.row.data
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Status",
                                      prop: "status",
                                      align: "left",
                                      width: "130"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return _c(
                                              "div",
                                              {},
                                              [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    staticClass:
                                                      "rounded-pill text-center",
                                                    style: {
                                                      minWidth: "100px"
                                                    },
                                                    attrs: {
                                                      type: _vm.getEventColorByStatus(
                                                        scope.row.status
                                                      ),
                                                      size: "small"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          scope.row.status
                                                        ) +
                                                        "\n                                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Titulo",
                                      prop: "titulo",
                                      align: "left",
                                      "min-width": "200"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return _c("div", {}, [
                                              _vm._v(_vm._s(scope.row.titulo))
                                            ])
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Despesas",
                                      align: "left",
                                      width: "140"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return _c("div", {}, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                  style: {
                                                    gap: "4px",
                                                    fontSize: "16px"
                                                  }
                                                },
                                                [
                                                  scope.row.viagem
                                                    ? _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            content: "Viagem",
                                                            placement: "left"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "border rounded p-1"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-map-location"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  scope.row.hospedagem
                                                    ? _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            content:
                                                              "Hospedagem",
                                                            placement: "left"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "border rounded p-1"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-school"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  scope.row.almoco
                                                    ? _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            content: "Almoço",
                                                            placement: "left"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "border rounded p-1"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-food"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  scope.row.jantar
                                                    ? _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            content: "Jantar",
                                                            placement: "left"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "border rounded p-1"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-dish"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ])
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Analisado por",
                                      width: "230",
                                      align: "left"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              scope.row.analisado_por
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center",
                                                      style: { gap: "8px" }
                                                    },
                                                    [
                                                      _c(
                                                        "el-avatar",
                                                        {
                                                          attrs: {
                                                            size: "small"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                scope.row.analisado_por.name.charAt(
                                                                  0
                                                                )
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-column",
                                                          style: {
                                                            minWidth: 0,
                                                            flex: 1
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-truncate text-capitalize",
                                                              style: {
                                                                fontSize: "12px"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    scope.row.analisado_por.name.toLowerCase()
                                                                  ) +
                                                                  "\n                                            "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "info",
                                                        size: "small"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        Não analisado\n                                    "
                                                      )
                                                    ]
                                                  )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  !_vm.isExport
                                    ? _c(
                                        "el-table-column",
                                        {
                                          attrs: {
                                            fixed: "right",
                                            width: 75,
                                            align: "right"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(scope) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex justify-content-between"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            style: {
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                              flexDirection:
                                                                "column",
                                                              gap: "4px",
                                                              maxWidth: "300px"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "el-button",
                                                              {
                                                                style: {
                                                                  width: "100%"
                                                                },
                                                                attrs: {
                                                                  size: "mini",
                                                                  type:
                                                                    "primary",
                                                                  plain: ""
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.dispatchEvent(
                                                                      scope.row
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-right"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-date"
                                                                })
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-menu"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eba0ffda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eba0ffda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/EventsSemanalView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-eba0ffda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/agenda/EventsSemanalView.vue
// module chunks = 2